import React from 'react';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import ScheduleIcon from '@mui/icons-material/Schedule';

const ObjectCard = ({ objects, handleEdit, handleDelete, handleMode }) => {
  const buttons = [
    { name: 'Vacation Mode', Icon: ScheduleIcon, onClick: handleMode },
    { name: 'Edit', Icon: ModeEditOutlineOutlinedIcon, onClick: handleEdit },
    { name: 'Delete', Icon: DeleteForeverOutlinedIcon, onClick: handleDelete },
  ];

  return (
    <>
      {objects.length !== 0 && (
        <div className="bg-white shadow-3xl rounded-3xl py-4 px-6">
          <div className="text-left text-base font-normal text-gray-800 pb-2">Адрес</div>
          {objects.map((object) => {
            return (
              <div key={object?.id} className="flex justify-between gap-x-2 text-left text-lg sm:text-xl font-normal py-4">
                <p className="line-clamp-1">{`${object.address}, кв  ${object.apartment}`}</p>
                <div className="flex items-center gap-x-2">
                  {buttons.map(({ name, Icon, onClick }) => {
                    return (
                      <div
                        key={name}
                        onClick={() => onClick(object)}
                        className="cursor-pointer flex items-center justify-center bg-orange-500 hover:bg-orange-600 rounded-full p-1">
                        <Icon className="text-white w-6 sm:w-6 xl:w-8 2xl:w-8 h-6 sm:h-6 xl:h-7 2xl:h-7" />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
export default ObjectCard;
